import { serviceName } from '../resources/serviceConstants';
import { ADD_PROPERTY, DELETE_PROPERTY, FETCH_PROPERTY_DETAILS, FETCH_IMAGE, FETCH_ALL_PROPERTY, UPLOAD_FILE, FETCH_REQUIRED_DOCUMENTS } from '../resources/endPoint';

export const addPropertyDetail = (data) => {
  // Get userId from localStorage
  const userStr = localStorage.getItem('user');
  const userId = userStr ? JSON.parse(userStr).id : null;

  return {
    url: ADD_PROPERTY,
    method: 'post',
    headers: {
      'content-type': 'application/json',
      isAuthToken: true,
    },
    authRequired: true,
    csrfToken: true,
    payload: { ...data, userId },
    service: serviceName.PROJECT_MS,
  };
};
export const uploadFiles = (formData) => {
  return {
    url: UPLOAD_FILE,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data',
      isAuthToken: true,
    },
    authRequired: true,
    csrfToken: true,
    payload: formData,
    service: serviceName.PROJECT_MS,
  };
};
export const fetchRequiredDocuments = (data) => {
  return {
    url: FETCH_REQUIRED_DOCUMENTS,
    method: 'post',
    headers: {
      'content-type': 'application/json',
      isAuthToken: true,
    },
    authRequired: true,
    payload: data,
    csrfToken: true,
    service: serviceName.PROJECT_MS,
  };
};
export const fetchAllProperty = (data) => {
  return {
    url: FETCH_ALL_PROPERTY,
    method: 'post',
    headers: {
      'content-type': 'application/json',
      isAuthToken: true,
    },
    authRequired: true,
    csrfToken: true,
    payload: data,
    service: serviceName.PROJECT_MS,
  };
};
export const fetchPropertyDetail = (data) => {
  return {
    url: FETCH_PROPERTY_DETAILS,
    method: 'post',
    headers: {
      'content-type': 'application/json',
      isAuthToken: true,
    },
    authRequired: true,
    payload: data,
    csrfToken: true,
    service: serviceName.PROJECT_MS,
  };
};
export const fetchFileById = (data) => {
  return {
    url: FETCH_IMAGE,
    method: 'post',
    headers: {
      'content-type': 'application/json',
      isAuthToken: true,
    },
    authRequired: true,
    payload: data,
    csrfToken: true,
    service: serviceName.PROJECT_MS,
    responseType: 'blob', // Handle binary response
  };
};
export const deletePropertyDetail = (data) => {
  return {
    url: DELETE_PROPERTY,
    method: 'post',
    headers: {
      'content-type': 'application/json',
      isAuthToken: true,
    },
    authRequired: true,
    payload: data,
    csrfToken: true,
    service: serviceName.PROJECT_MS,
  };
};
